import React from 'react';
import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  return (
    <Wrapper>
      <Inner>
        <FooterLink as={RouterLink} to="/privacy">Privacy Policy</FooterLink>
        <Dot>·</Dot>
        <Copyright>© {new Date().getFullYear()} Abel Mendoza</Copyright>
        <Dot>·</Dot>
        <Curse>☠️ abeliciousness.com ☠️</Curse>
      </Inner>
    </Wrapper>
  );
};

export default Footer;

const Wrapper = styled.footer`
  width: 100%;
  background: rgba(0, 0, 0, 0.85);
  border-top: 1px solid rgba(148, 0, 211, 0.35);
  box-shadow: 0 -2px 18px rgba(76, 0, 101, 0.25);
  padding: 14px 20px;
  box-sizing: border-box;
`;

const Inner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  font-family: 'Creepster', Arial, sans-serif;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.45);

  @media (max-width: 430px) {
    flex-direction: column;
    gap: 4px;
    font-size: 0.78rem;
  }
`;

const FooterLink = styled.a`
  text-decoration: none;
  color: rgba(255, 255, 255, 0.45);
  transition: color 0.2s;
  &:hover { color: #cc44ff; }
`;

const Dot = styled.span`
  color: rgba(148, 0, 211, 0.4);

  @media (max-width: 430px) {
    display: none;
  }
`;

const Copyright = styled.span``;

const Curse = styled.span`
  color: rgba(148, 0, 211, 0.55);
  letter-spacing: 1px;
`;
